//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("validation", ValidationFactory);

    ValidationFactory.$inject = ["apiClientFactory"];
    function ValidationFactory(apiClientFactory) {

        const routePrefix = "api/Validation/";

        return {
            BelgianReferenceNumber: apiClientFactory.post(routePrefix + "BelgianReferenceNumber/"),
            Email: apiClientFactory.post(routePrefix + "Email/"),
        };
    }
})();
